var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","href":_vm.docUrl (_vm.value.id)}},[_vm._v(" "+_vm._s(_vm.$t ('label.downloadAllDocs'))+" "),_c('v-icon',[_vm._v("get_app")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }